module.exports = __webpack_public_path__ + "static/media/tabledownarrow.5fa554c3.svg";